@if (hasVideo) {
    <i  class="icon-caption" (click)="capturePhoto()"></i>
}
